import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Projects from "./Projects/Projects";
import { Layout } from "./Common/Layout/Layout";
import Loading from "./Common/Components/Loading";
import { BDTRoutes } from "../helpers/applicationConstants";
import ErrorBoundary from "./Common/Components/ErrorBoundary";
import { PanelProjectProvider } from "./PanelProjectProvider";
import Redirect from "./Common/Layout/Redirect";

const Administration = React.lazy(() => import("./Administration/Administration"));
const Project = React.lazy(() => import("./Project/Project"));

const BIMDigitalTwin = (): JSX.Element => {
    const { t } = useTranslation("main");

    return (
        <PanelProjectProvider>
            <Redirect />
            <Layout>
                <ErrorBoundary errorMessage={t("BIMDigitalTwin.mainError")}>
                    <Suspense fallback={<Loading />}>
                        <Switch>
                            <Route exact path={BDTRoutes.Home} component={Projects} />
                            <Route
                                path={BDTRoutes.Administration.Administration}
                                component={Administration}
                            />
                            <Route path={BDTRoutes.Project.Project.Path} component={Project} />
                        </Switch>
                    </Suspense>
                </ErrorBoundary>
            </Layout>
        </PanelProjectProvider>
    );
};

export default BIMDigitalTwin;
